<template>
  <div class="order-conform">
    <section class="dialog-header">
      <h1>Bedankt voor uw order</h1>
    </section>
    <section class="dialog-content">
      <p v-if="wantsConfirmation">
        U ontvangt van ons een email met uw orderbevestiging.
      </p>

      <div class="button-holder">
        <button class="pill-button" @click="close">
          {{ actionLabel }}
        </button>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    callback: Function,
    actionLabel: {
      type: String,
      default: 'sluiten'
    },
    countdown: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  computed: {
    wantsConfirmation() {
      return this.rootStore.user.notificationPreferences.orderConfirmation || true
    }
  },
  created() {
    this.$router.push({ name: 'home' })
    this.rootStore.setHome()

    if (this.countdown > 0) {
      setTimeout(() => {
        this.close()
      }, this.countdown * 1000)
    }
  },
  methods: {
    close() {
      if (this.callback) {
        this.callback()
      }
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped></style>
